import React, { useState, useEffect } from 'react';
import ProfileLayout from '../../components/ProfileLayout';
import OrdersHistoryContent from '../../components/OrdersHistoryContent';
import { websiteAPI } from '../../api/api';

const OrdersHistoryPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const data = await websiteAPI.getOrders();
        
        // Transform orders to match the component's expected format
        const transformedOrders = data.orders.map(order => ({
          id: `#${order.id}`,
          game: order.product_name || 'Пополнение',
          date: order.date || '-',
          amount: order.amount ? `${order.amount} ${order.currency}` : '-',
          status: order.status
        }));
        
        setOrders(transformedOrders);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch orders:', err);
        setError('Не удалось загрузить историю заказов');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  return (
    <ProfileLayout activeItem="orders">
      <OrdersHistoryContent 
        orders={orders} 
        loading={loading}
        error={error}
      />
    </ProfileLayout>
  );
};

export default OrdersHistoryPage;
